<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>Tarifas — Configuracion Global</f7-nav-title>
      <f7-nav-right><HelpButton titulo="Configuracion Global de Tarifas" :contenido="helpConfigHTML" /></f7-nav-right>
    </f7-navbar>

    <div class="cfg-wrap">
      <!-- Card 1: Precio hora y desplazamiento -->
      <f7-card class="cfg-card">
        <div class="cfg-ch">Precio hora y desplazamiento</div>
        <f7-card-content>
          <f7-list no-hairlines-md>
            <f7-list-input label="Precio/hora (ph)" type="number" :value="cfg.ph" step="0.01" @input="cfg.ph = parseFloat($event.target.value) || 0"></f7-list-input>
            <f7-list-input label="Coste km (kmcost)" type="number" :value="cfg.kmcost" step="0.01" @input="cfg.kmcost = parseFloat($event.target.value) || 0"></f7-list-input>
            <f7-list-input label="Km minimos (kmmin)" type="number" :value="cfg.kmmin" @input="cfg.kmmin = parseInt($event.target.value) || 0"></f7-list-input>
            <f7-list-input label="Tiempo desp. min/km (tdf)" type="number" :value="cfg.tdf" step="0.01" @input="cfg.tdf = parseFloat($event.target.value) || 0"></f7-list-input>
          </f7-list>
        </f7-card-content>
      </f7-card>

      <!-- Card 2: Manutencion -->
      <f7-card class="cfg-card">
        <div class="cfg-ch">Manutencion</div>
        <f7-card-content>
          <f7-list no-hairlines-md>
            <f7-list-input label="Comida (com)" type="number" :value="cfg.com" step="0.5" @input="cfg.com = parseFloat($event.target.value) || 0"></f7-list-input>
            <f7-list-input label="Cena (cen)" type="number" :value="cfg.cen" step="0.5" @input="cfg.cen = parseFloat($event.target.value) || 0"></f7-list-input>
            <f7-list-input label="Hotel (hot)" type="number" :value="cfg.hot" step="1" @input="cfg.hot = parseFloat($event.target.value) || 0"></f7-list-input>
            <f7-list-input label="Desayuno (des)" type="number" :value="cfg.des" step="0.5" @input="cfg.des = parseFloat($event.target.value) || 0"></f7-list-input>
          </f7-list>
        </f7-card-content>
      </f7-card>

      <!-- Card 3: Recargos -->
      <f7-card class="cfg-card">
        <div class="cfg-ch">Recargos</div>
        <f7-card-content>
          <f7-list no-hairlines-md>
            <f7-list-input label="Recargo Fin de Semana % (pctFS)" type="number" :value="cfg.pctFS" step="1" @input="cfg.pctFS = parseFloat($event.target.value) || 0"></f7-list-input>
            <f7-list-input label="Recargo Nocturno % (pctNocturno)" type="number" :value="cfg.pctNocturno" step="1" @input="cfg.pctNocturno = parseFloat($event.target.value) || 0"></f7-list-input>
          </f7-list>
        </f7-card-content>
      </f7-card>

      <!-- Version info con fechas -->
      <f7-card class="cfg-card" v-if="cfg.version">
        <div class="cfg-ch">Version actual</div>
        <f7-card-content>
          <div class="cfg-version-grid">
            <div><b>Version:</b> {{ cfg.version }}</div>
            <div><b>Vigente desde:</b> {{ formatFecha(cfg.fechaDesde) }}</div>
            <div><b>Hasta:</b> {{ cfg.fechaHasta ? formatFecha(cfg.fechaHasta) : 'Vigente' }}</div>
            <div v-if="cfg.motivo"><b>Motivo:</b> {{ cfg.motivo }}</div>
          </div>
        </f7-card-content>
      </f7-card>

      <!-- Motivo del cambio -->
      <f7-card class="cfg-card">
        <div class="cfg-ch">Motivo del cambio</div>
        <f7-card-content>
          <f7-list no-hairlines-md>
            <f7-list-input label="Motivo" type="textarea" :value="motivo" @input="motivo = $event.target.value" placeholder="Describa el motivo del cambio..." :resizable="true"></f7-list-input>
          </f7-list>
        </f7-card-content>
      </f7-card>

      <div class="padding">
        <f7-button large fill color="orange" @click="abrirSelectorHerramientas">Guardar Configuracion</f7-button>
        <div v-if="cfg.fechaModificacion" class="cfg-mod">
          Ultima modificacion: {{ cfg.fechaModificacion }} por {{ cfg.usuarioModificacion || '—' }}
        </div>
      </div>

      <!-- Historial con filtros -->
      <f7-card class="cfg-card" style="margin-top:16px">
        <div class="cfg-ch">Historial de versiones</div>
        <f7-card-content>
          <div class="cfg-filtros">
            <div class="cfg-filtro-item">
              <label>Herramienta:</label>
              <select v-model="filtroHerramienta" class="cfg-select">
                <option value="">Todas</option>
                <option v-for="h in herramientas" :key="h.codigo" :value="h.codigo">{{ h.codigo }} — {{ h.nombre }}</option>
              </select>
            </div>
            <div class="cfg-filtro-item">
              <label>Desde:</label>
              <input type="date" v-model="filtroFechaDesde" class="cfg-date-input" />
            </div>
            <div class="cfg-filtro-item">
              <label>Hasta:</label>
              <input type="date" v-model="filtroFechaHasta" class="cfg-date-input" />
            </div>
            <f7-button small fill color="blue" @click="cargarHistorial">Filtrar</f7-button>
          </div>

          <div v-if="!historial.length" style="font-size:11px;color:#999;text-align:center;padding:12px">Sin historial disponible</div>
          <div v-else style="overflow-x:auto">
            <table class="cfg-hist-table">
              <thead>
                <tr>
                  <th>Version</th>
                  <th>Fecha desde</th>
                  <th>Fecha hasta</th>
                  <!--
                    Las diez columnas de valores son las diez cajas que esta misma pantalla deja
                    editar. Antes solo salian PH, %FS y %Noct, y por eso quien cambiaba el coste por
                    kilometro no tenia forma de leer el que habia antes para devolverlo: el historial
                    enseñaba la version en la que se cambio pero no el valor que se cambio (#387,
                    17/10/2026). La tabla ya se desplaza en horizontal.
                  -->
                  <th>PH</th>
                  <th>Km cost</th>
                  <th>Km min</th>
                  <th>TDF</th>
                  <th>Comida</th>
                  <th>Cena</th>
                  <th>Hotel</th>
                  <th>Desay.</th>
                  <th>%FS</th>
                  <th>%Noct</th>
                  <th>Motivo</th>
                  <th>Usuario</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(h, idx) in historial" :key="idx">
                  <td>{{ h.version }}</td>
                  <td>{{ formatFecha(h.fechaDesde) }}</td>
                  <td>{{ h.fechaHasta ? formatFecha(h.fechaHasta) : 'Vigente' }}</td>
                  <td>{{ valorDeLaVersion(h.ph) }}</td>
                  <td>{{ valorDeLaVersion(h.kmcost) }}</td>
                  <td>{{ valorDeLaVersion(h.kmmin) }}</td>
                  <td>{{ valorDeLaVersion(h.tdf) }}</td>
                  <td>{{ valorDeLaVersion(h.com) }}</td>
                  <td>{{ valorDeLaVersion(h.cen) }}</td>
                  <td>{{ valorDeLaVersion(h.hot) }}</td>
                  <td>{{ valorDeLaVersion(h.des) }}</td>
                  <td>{{ valorDeLaVersion(h.pctFS) }}</td>
                  <td>{{ valorDeLaVersion(h.pctNocturno) }}</td>
                  <td>{{ h.motivo || '—' }}</td>
                  <td>{{ h.usuarioModificacion || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </f7-card-content>
      </f7-card>
    </div>

    <!-- Popup selector de herramientas -->
    <f7-popup :opened="selectorOpen" @popup:close="selectorOpen = false" class="cfg-selector-popup">
      <f7-page>
        <f7-navbar title="Seleccionar herramientas a actualizar">
          <f7-nav-left><f7-link popup-close icon-f7="xmark"></f7-link></f7-nav-left>
        </f7-navbar>
        <f7-page-content>
          <f7-block>
            <p style="font-size:12px;color:#555">
              Al guardar la configuracion global, se creara una nueva version de cada herramienta seleccionada
              con los valores actualizados. Las herramientas no seleccionadas quedaran intactas.
            </p>
          </f7-block>
          <f7-block class="no-margin-top">
            <f7-row>
              <f7-button small outline color="blue" @click="seleccionarTodas">Seleccionar todas</f7-button>
              <f7-button small outline color="gray" class="margin-left" @click="deseleccionarTodas">Deseleccionar todas</f7-button>
            </f7-row>
          </f7-block>
          <f7-list>
            <f7-list-item
              v-for="h in herramientas"
              :key="h.codigo"
              checkbox
              :checked="herramientasSeleccionadas.indexOf(h.codigo) >= 0"
              @change="toggleHerramienta(h.codigo, $event.target.checked)"
              :title="h.nombre + ' (v.' + (h.version||1) + ')'"
              :after="h.codigo"
            ></f7-list-item>
          </f7-list>
          <f7-block>
            <div class="cfg-selector-resumen">
              {{ herramientasSeleccionadas.length }} de {{ herramientas.length }} herramientas seleccionadas
            </div>
            <f7-button large fill color="orange" @click="confirmarGuardado" :disabled="guardando">
              {{ guardando ? 'Guardando...' : 'Confirmar y guardar' }}
            </f7-button>
            <f7-button large class="margin-top" @click="selectorOpen = false">Cancelar</f7-button>
          </f7-block>
        </f7-page-content>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>

<script>
import Tarifa from './../../js/db/Tarifa.js';
import HelpButton from './../../components/HelpButton.vue';
import cerrojoDeLaSesion from './../../js/utils/cerrojoDeLaSesion.js';

const HELP_CONFIG = '<h3>Que es?</h3><p>Aqui se configuran los valores que aplican a TODAS las herramientas de tarifas. Cualquier cambio se refleja inmediatamente en todos los calculadores.</p><h3>Precio y desplazamiento</h3><ul><li><b>Precio/hora (PH):</b> Precio por hora de trabajo del inspector. Actualmente 107 eur/h. Se aplica a todas las herramientas por igual</li><li><b>Coste km:</b> Precio por kilometro de desplazamiento. Actualmente 0.29 eur/km, fijado por direccion el 06/10/2026. Base de coste: renting 500 eur/mes entre 3.333 km/mes = 0,1500 eur/km, mas combustible 7 l/100 km a 2,10 eur/l = 0,1470 eur/km; suman <b>0,2970 eur/km</b>, y direccion dejo el valor en 0,29 truncando los centimos (no redondeando a 0,30)</li><li><b>Km minimos:</b> Kilometraje minimo que se cobra aunque la instalacion este mas cerca. Actualmente 60 km</li><li><b>Min/km desplazamiento:</b> Factor para calcular el tiempo de desplazamiento en minutos. Actualmente 0.65 min/km</li></ul><h3>Manutencion</h3><ul><li><b>Comida:</b> Precio por comida cuando la inspeccion supera las 5 horas (14 eur)</li><li><b>Cena:</b> Precio por cena cuando la inspeccion requiere pernoctar (14 eur)</li><li><b>Hotel:</b> Precio por noche de hotel (60 eur)</li><li><b>Desayuno:</b> Precio por desayuno incluido con hotel (4 eur)</li></ul><h3>Recargos</h3><ul><li><b>% Fin de semana:</b> Porcentaje de recargo sobre el precio de trabajo cuando la inspeccion se realiza en fin de semana (30%)</li><li><b>% Horas nocturnas:</b> Porcentaje de recargo para inspecciones en horario nocturno (35%)</li><li>Ambos recargos son acumulables</li></ul>';

export default {
  components: { HelpButton },
  data: function() {
    return {
      helpConfigHTML: HELP_CONFIG,
      cfg: {
        // Valores fijados por direccion el 06/10/2026 (#370); los sustituye lo que devuelva la API.
        ph: 107, kmcost: 0.29, kmmin: 60, tdf: 0.65,
        com: 14, cen: 14, hot: 60, des: 4,
        pctFS: 30, pctNocturno: 35
      },
      motivo: '',
      historial: [],
      herramientas: [],
      herramientasSeleccionadas: [],
      selectorOpen: false,
      guardando: false,
      filtroHerramienta: '',
      filtroFechaDesde: '',
      filtroFechaHasta: ''
    };
  },
  mounted: function() {
    this.cargar();
    this.cargarHistorial();
    this.cargarHerramientas();
  },
  methods: {
    cargar: function() {
      var self = this;
      Tarifa.getConfig(true).then(function(res) {
        if (res && res.ph) {
          self.cfg = Object.assign({}, self.cfg, res);
        }
      }).catch(function(e) {
        self.$f7.dialog.alert('Error cargando config: ' + (e.message || ''));
      });
    },
    cargarHerramientas: function() {
      var self = this;
      Tarifa.getHerramientas().then(function(res) {
        var list = res.list || res || [];
        self.herramientas = Array.isArray(list) ? list : [];
      }).catch(function() {
        self.herramientas = [];
      });
    },
    abrirSelectorHerramientas: function() {
      if (!this.motivo || !this.motivo.trim()) {
        this.$f7.dialog.alert('Debe indicar un motivo del cambio');
        return;
      }
      this.herramientasSeleccionadas = this.herramientas.map(function(h) { return h.codigo; });
      this.selectorOpen = true;
    },
    seleccionarTodas: function() {
      this.herramientasSeleccionadas = this.herramientas.map(function(h) { return h.codigo; });
    },
    deseleccionarTodas: function() {
      this.herramientasSeleccionadas = [];
    },
    toggleHerramienta: function(codigo, checked) {
      var idx = this.herramientasSeleccionadas.indexOf(codigo);
      if (checked && idx < 0) {
        this.herramientasSeleccionadas.push(codigo);
      } else if (!checked && idx >= 0) {
        this.herramientasSeleccionadas.splice(idx, 1);
      }
    },
    confirmarGuardado: function() {
      var self = this;
      // #663 · Cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla el `finally` que lo soltaba.
      cerrojoDeLaSesion(self, 'guardando');
      var data = {
        config: Object.assign({}, self.cfg),
        motivo: self.motivo || '',
        herramientaCodigos: self.herramientasSeleccionadas
      };
      Tarifa.updateConfigConHerramientas({ data: data }).then(function(res) {
        self.selectorOpen = false;
        self.$f7.dialog.alert(self.resumenDeLaAplicacion(res));
        self.motivo = '';
        self.cargar();
        self.cargarHistorial();
        // Las herramientas estrenan version y «Vigente desde» con esta aplicacion (#387), asi que
        // la lista del selector —que pinta la version de cada una— se vuelve a leer: dejarla con la
        // anterior hace que la siguiente aplicacion se lance mirando un numero que ya no es.
        self.cargarHerramientas();
      }).catch(function(e) {
        self.$f7.dialog.alert('Error: ' + (e.message || ''));
      }).finally(function() {
        self.guardando = false;
      });
    },
    /**
     * Lo que se le dice a quien acaba de aplicar la configuracion global, contando lo que la API
     * dice que ha pasado y no lo que se habia pedido.
     *
     * Antes era `(res.herramientasActualizadas) || seleccionadas.length`, y ese `||` convertia el
     * cero en el numero de herramientas marcadas: con ninguna sellada, la pantalla decia «19
     * herramientas actualizadas». Es la misma forma del defecto que arregla la #387 —un dato que
     * afirma mas de lo que sostiene— y por eso se cierra aqui tambien.
     *
     * Y si alguna se queda sin sellar se nombra: «18 de 19» obliga a restar para saber cual falta, y
     * restando no se distingue una que fallo al escribirse de una que no tiene version en vigor.
     */
    resumenDeLaAplicacion: function(res) {
      const selladas = (res && typeof res.herramientasActualizadas === 'number')
        ? res.herramientasActualizadas
        : 0;
      const pedidas = (res && typeof res.herramientasSolicitadas === 'number')
        ? res.herramientasSolicitadas
        : this.herramientasSeleccionadas.length;
      let texto = 'Configuracion guardada. ' + selladas + ' de ' + pedidas
        + ' herramientas han subido de version con esta configuracion.';
      const sinSellar = (res && res.herramientasNoSelladas) || [];
      if (sinSellar.length) {
        texto += '\n\nSin actualizar: ' + sinSellar.join('; ') + '.';
      }
      if (res && res.selladoSeDetuvo) {
        texto += '\n\nLa pasada se detuvo: ' + (res.motivoDeLaParada || 'no se pudo garantizar')
          + '. La configuracion global SI esta publicada; vuelve a aplicarla a las que falten.';
      }
      return texto;
    },
    cargarHistorial: function() {
      var self = this;
      var filtros = {};
      if (self.filtroHerramienta) filtros.herramientaCodigo = self.filtroHerramienta;
      if (self.filtroFechaDesde) filtros.fechaDesde = self.filtroFechaDesde;
      if (self.filtroFechaHasta) filtros.fechaHasta = self.filtroFechaHasta;
      Tarifa.getConfigHistorial(filtros).then(function(res) {
        self.historial = res || [];
      }).catch(function() {
        self.historial = [];
      });
    },
    /**
     * Un valor del historial, o una raya si esa version no lo trae.
     *
     * La raya y no el hueco en blanco: una celda vacia en una tabla de valores se lee como un cero,
     * y «el desayuno valia 0» no es lo mismo que «esta version no guardo el desayuno». El cero si se
     * pinta, que para eso es un valor.
     */
    valorDeLaVersion: function(valor) {
      return (valor === null || valor === undefined || valor === '') ? '—' : valor;
    },
    formatFecha: function(str) {
      if (!str) return '—';
      try {
        var d = new Date(str);
        if (isNaN(d.getTime())) return str;
        var dd = String(d.getDate()).padStart(2, '0');
        var mm = String(d.getMonth() + 1).padStart(2, '0');
        var yyyy = d.getFullYear();
        return dd + '/' + mm + '/' + yyyy;
      } catch (e) {
        return str;
      }
    }
  }
};
</script>

<style scoped>
.cfg-wrap{max-width:600px;margin:0 auto;padding:8px}
.cfg-card{margin-bottom:10px;border-radius:7px;overflow:hidden;border:0.5px solid #e2e8f0}
.cfg-ch{padding:5px 8px;font-size:10px;font-weight:700;color:#fff;background:#1a2744;text-transform:uppercase;letter-spacing:.05em}
.cfg-mod{margin-top:8px;font-size:10px;color:#888;text-align:center}
.cfg-version-grid{display:flex;gap:16px;flex-wrap:wrap;font-size:11px;color:#555}
.cfg-hist-table{width:100%;border-collapse:collapse;font-size:10px}
.cfg-hist-table th,.cfg-hist-table td{padding:4px 6px;border-bottom:1px solid #e2e8f0;text-align:left}
.cfg-hist-table th{font-weight:700;color:#555;background:#f8fafc}
.cfg-hist-table td{color:#333}
.cfg-filtros{display:flex;align-items:flex-end;gap:8px;flex-wrap:wrap;margin-bottom:10px;padding:8px;background:#f8fafc;border-radius:5px}
.cfg-filtro-item{display:flex;flex-direction:column;gap:2px}
.cfg-filtro-item label{font-size:9px;font-weight:700;color:#555;text-transform:uppercase}
.cfg-select{padding:4px 6px;border:1px solid #d1d9e0;border-radius:4px;font-size:11px;min-width:160px}
.cfg-date-input{padding:4px 6px;border:1px solid #d1d9e0;border-radius:4px;font-size:11px;min-width:120px}
.cfg-selector-popup{--f7-popup-tablet-width:480px}
.cfg-selector-resumen{text-align:center;font-size:12px;font-weight:600;color:#1a2744;margin-bottom:12px}
</style>
